import { render, staticRenderFns } from "./BookUpgrade.vue?vue&type=template&id=c28f4b22"
import script from "./BookUpgrade.vue?vue&type=script&lang=js"
export * from "./BookUpgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports